// import 'regenerator-runtime/runtime';
import React from 'react';
import { render } from 'react-dom';
import App from './root';

import './components/App/App.scss';

// if ('serviceWorker' in navigator) {
//   window.addEventListener('load', () => {
//     navigator.serviceWorker
//       .register('/service-worker.js')
//       .then(registration => {
//         console.error('SW registered: ', registration);
//       })
//       .catch(registrationError => {
//         console.error('SW registration failed: ', registrationError);
//       });
//   });
// }
const rootNode = document.createElement('div');

if (document.body) {
  document.body.appendChild(rootNode);
}

render(<App />, document.getElementById('app'));
